<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
     <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">KEUANGAN</span>
                <span v-else>FINANCE</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Keuangan</span>
                    <span v-else>Finance</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">
        <div class="container-fluid py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        REKAPITULASI REALISASI KEGIATAN
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        RECAPITULATION OF REALIZATION OF ACTIVITIES
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Tanggal Data: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                </p>
                <p class="mb-0" v-else>
                    Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="row">
                    <div class="col-sm-12 wow fadeInDown">
                        <div class="card cardputih collapsed-card" style="display: none;">
                            <div class="card-header border-transparent" data-card-widget="collapse"
                                style="cursor: pointer;">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                                    <span v-else>Column Filter</span>
                                </label>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body px-3">
                                <div class="row">
                                    <div class="col-sm-2" style="display:none">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOWPPMIS" value="optionOWPPMIS"
                                                @click="showColumnOWPPMIS = !showColumnOWPPMIS" checked>
                                            <label for="customCheckboxOWPPMIS" class="custom-control-label">
                                                OWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOWPMONEV" value="optionOWPMONEV"
                                                @click="showColumnOWPMONEV = !showColumnOWPMONEV" checked>
                                            <label for="customCheckboxOWPMONEV" class="custom-control-label">
                                                OWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2" style="display:none">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxAWPPMIS" value="optionAWPPMIS"
                                                @click="showColumnAWPPMIS = !showColumnAWPPMIS" checked>
                                            <label for="customCheckboxAWPPMIS" class="custom-control-label">
                                                AWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxAWPMONEV" value="optionAWPMONEV"
                                                @click="showColumnAWPMONEV = !showColumnAWPMONEV" checked>
                                            <label for="customCheckboxAWPMONEV" class="custom-control-label">
                                                AWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2" style="display:none">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxDIPAPMIS" value="optionDIPAPMIS"
                                                @click="showColumnDIPAPMIS = !showColumnDIPAPMIS" checked>
                                            <label for="customCheckboxDIPAPMIS" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">DIPA</span>
                                                <span v-else>Table of Contents Implementation Budget</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxDIPAMONEV" value="optionDIPAMONEV"
                                                @click="showColumnDIPAMONEV = !showColumnDIPAMONEV" checked>
                                            <label for="customCheckboxDIPAMONEV" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">DIPA</span>
                                                <span v-else>Table of Contents Implementation Budget</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxSPMPMIS" value="optionSPMPMIS"
                                                @click="showColumnSPMPMIS = !showColumnSPMPMIS" checked>
                                            <label for="customCheckboxSPMPMIS" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi</span>
                                                <span v-else>Realization</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 text-center wow fadeInUp" data-wow-delay="0.1s">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_Finance_')">
                            <i class="fas fa-download"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data .xlsx
                            </span>
                            <span v-else>
                                Download Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldata1" style="font-size: 10px !important;">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" rowspan="2">No</th>
                                    <th style="width: 250px;" rowspan="2">CPMU/CPIU/PIU</th>
                                    <th style="width: 100px;" rowspan="2" v-if="showColumnOWPMONEV">OWP<br>(IDR)</th>
                                    <template v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        <th colspan="4" v-if="listtahun.tahun <= tahunsekarang">
                                            {{ listtahun.tahun }}
                                        </th>
                                    </template>
                                    <th style="width: 100px;" rowspan="2" v-if="showColumnOWPMONEV">
                                        <span
                                            v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>Kumulatif<br>(IDR)</span>
                                        <span v-else>Cumulative<br>Realization<br>(IDR)</span>
                                    </th>
                                    <th style="width: 10px;" rowspan="2" v-if="showColumnOWPMONEV">
                                        <span
                                            v-if="(bahasa === null) || (bahasa == 'ina')">Persentase<br>Realisasi<br>ke
                                            OWP<br></br>(%)</span>
                                        <span v-else>Percentage of Realization<br>to OWP<br></br>(%)</span>
                                    </th>
                                </tr>
                                <tr>
                                    <template v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        <th style="width: 100px;" v-if="listtahun.tahun <= tahunsekarang">
                                            AWP<br>(IDR)
                                        </th>
                                        <th style="width: 100px;" v-if="listtahun.tahun <= tahunsekarang">
                                            DIPA<br>(IDR)
                                        </th>
                                        <th style="width: 100px;" v-if="listtahun.tahun <= tahunsekarang">
                                            <span
                                                v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>(IDR)</span>
                                            <span v-else>Realization<br>(IDR)</span>
                                        </th>
                                        <th style="width: 10px;" v-if="listtahun.tahun <= tahunsekarang">
                                            <span
                                                v-if="(bahasa === null) || (bahasa == 'ina')">Persentase<br>Realisasi<br>ke
                                                DIPA<br></br>(%)</span>
                                            <span v-else>Percentage<br>of Realization<br>to DIPA<br></br>(%)</span>
                                        </th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(datalist, urutlist) in datatotal" :key="urutlist">
                                    <tr>
                                        <td class="total" colspan="2"> TOTAL</td>
                                        <td class="totalkanan" :data-v="datalist.owptotal" data-z="#,##0.00">{{
                                            G_numFormat(datalist.owptotal) }}
                                        </td>
                                        <template v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                            <td class="totalkanan" :data-v="listtahun.awp" data-z="#,##0.00"
                                                v-if="listtahun.tahun <= tahunsekarang">
                                                {{ G_numFormat(listtahun.awp) }}
                                            </td>
                                            <td class="totalkanan" :data-v="listtahun.dipa" data-z="#,##0.00"
                                                v-if="listtahun.tahun <= tahunsekarang">
                                                {{ G_numFormat(listtahun.dipa) }}
                                            </td>
                                            <td class="totalkanan" :data-v="listtahun.spm" data-z="#,##0.00"
                                                v-if="listtahun.tahun <= tahunsekarang">
                                                {{ G_numFormat(listtahun.spm) }}
                                            </td>
                                            <td class="totalkanan" :data-v="listtahun.persenkedipa" data-z="#,##0.00"
                                                v-if="listtahun.tahun <= tahunsekarang">
                                                {{ G_numKoma(listtahun.persenkedipa) }}
                                            </td>
                                        </template>
                                        <td class="totalkanan" :data-v="datalist.spmtotal" data-z="#,##0.00">{{
                                            G_numFormat(datalist.spmtotal) }}
                                        </td>
                                        <td class="totalkanan" :data-v="datalist.perserntotal" data-z="#,##0.00">{{
                                            G_numKoma(datalist.perserntotal) }}
                                        </td>
                                    </tr>
                                </template>
                                <template v-for="(datakonten, urutkonten) in datakonten" :key="urutkonten">
                                    <tr>
                                        <td data-z="#,##0" class="levelsubkomponen">
                                            {{ urutkonten + 1 }}
                                        </td>
                                        <td class="levelsubkomponen">
                                            {{ datakonten.NmSatker }}
                                        </td>
                                        <td class="text-right levelsubkomponen" v-if="showColumnOWPMONEV"
                                            :data-v="datakonten.OWPMONEV" data-z="#,##0.00">
                                            {{ G_numFormat(datakonten.OWPMONEV) }}
                                        </td>
                                        <template v-for="(datadetail, urutdetail) in datakonten.Detail"
                                            :key="urutdetail">
                                            <td class="text-right levelsubkomponen" :data-v="datadetail.awpmonev"
                                                data-z="#,##0.00" v-if="datadetail.tahun <= tahunsekarang">
                                                {{ G_numFormat(datadetail.awpmonev) }}
                                            </td>
                                            <td class="text-right levelsubkomponen" :data-v="datadetail.dipamonev"
                                                data-z="#,##0.00" v-if="datadetail.tahun <= tahunsekarang">
                                                {{ G_numFormat(datadetail.dipamonev) }}
                                            </td>
                                            <td class="text-right levelsubkomponen" :data-v="datadetail.spm"
                                                data-z="#,##0.00" v-if="datadetail.tahun <= tahunsekarang">
                                                {{ G_numFormat(datadetail.spm) }}
                                            </td>
                                            <td class="text-right levelsubkomponen" :data-v="datadetail.persenkedipa"
                                                data-z="#,##0.00" v-if="datadetail.tahun <= tahunsekarang">
                                                {{ G_numKoma(datadetail.persenkedipa) }}
                                            </td>
                                        </template>
                                        <td class="text-right levelsubkomponen" v-if="showColumnOWPMONEV"
                                            :data-v="datakonten.SPMTOTAL" data-z="#,##0.00">
                                            {{ G_numFormat(datakonten.SPMTOTAL) }}
                                        </td>
                                        <td class="text-right levelsubkomponen" v-if="showColumnOWPMONEV"
                                            :data-v="datakonten.persenperpiuowp" data-z="#,##0.00">
                                            {{ G_numKoma(datakonten.persenperpiuowp) }}
                                        </td>
                                    </tr>
                                    <template v-for="(datasatker, urutsatker) in datakonten.Satker" :key="urutsatker">
                                        <tr>
                                            <td data-z="#,##0">
                                                {{ urutkonten + 1 }}.{{ urutsatker + 1 }}
                                            </td>
                                            <td>
                                                {{ datasatker.nama_satker }}
                                            </td>
                                            <td class="text-right" v-if="showColumnOWPMONEV" :data-v="datasatker.OWP"
                                                data-z="#,##0.00">
                                                {{ G_numFormat(datasatker.OWP) }}
                                            </td>
                                            <template v-for="(datasatkerdetail, urutsatker) in datasatker.detailsatker"
                                                :key="urutsatker">
                                                <td class="text-right"
                                                    :data-v="datasatkerdetail.AWP" data-z="#,##0.00"
                                                    v-if="datasatkerdetail.tahun <= tahunsekarang">
                                                    {{ G_numFormat(datasatkerdetail.AWP) }}
                                                </td>
                                                <td class="text-right"
                                                    :data-v="datasatkerdetail.DIPA" data-z="#,##0.00"
                                                    v-if="datasatkerdetail.tahun <= tahunsekarang">
                                                    {{ G_numFormat(datasatkerdetail.DIPA) }}
                                                </td>
                                                <td class="text-right"
                                                    :data-v="datasatkerdetail.REALISASI" data-z="#,##0.00"
                                                    v-if="datasatkerdetail.tahun <= tahunsekarang">
                                                    {{ G_numFormat(datasatkerdetail.REALISASI) }}
                                                </td>
                                                <td class="text-right"
                                                    :data-v="datasatkerdetail.PERSENDIPA" data-z="#,##0.00"
                                                    v-if="datasatkerdetail.tahun <= tahunsekarang">
                                                    {{ G_numKoma(datasatkerdetail.PERSENDIPA) }}
                                                </td>
                                            </template>
                                            <td class="text-right" v-if="showColumnOWPMONEV" :data-v="datasatker.realisasitotal"
                                                data-z="#,##0.00">
                                                {{ G_numFormat(datasatker.realisasitotal) }}
                                            </td>
                                            <td class="text-right" v-if="showColumnOWPMONEV" :data-v="datasatker.persensatkerowp"
                                                data-z="#,##0.00">
                                                {{ G_numKoma(datasatker.persensatkerowp) }}
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                            <tbody v-if="(datapesan == 'data kosong')">
                                <label>Data masih kosong</label>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datakonten: [],
            datatotal: [],
            datatahun: [],
            tahun: new Date().getFullYear(),
            tahunsekarang: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            project_id: process.env.VUE_APP_PROJECT_ID,
            showColumnOWPPMIS: false,
            showColumnOWPMONEV: true,
            showColumnAWPPMIS: false,
            showColumnAWPMONEV: true,
            showColumnDIPAPMIS: false,
            showColumnDIPAMONEV: true,
            showColumnSPMPMIS: true,
        };
    },
    methods: {
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakkeuangan-AWPDanKeu?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-FinanceFMNJP?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster = [];
                    this.datakonten = [];
                    this.datatotal = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = Response.data.content.data;
                        this.tanggalsinkron = this.datamaster[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.datamaster[0].TanggalDataMonev;
                        this.datakonten = this.datamaster[0].Content;
                        this.datatahun = this.datamaster[0].TahunData;
                        this.datatotal = this.datamaster[0].Total;
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.tanggalsinkron = new Date();
                        this.tanggaldatamonev = new Date();
                        this.datakonten = [];
                        this.datatahun = [];
                        this.datatotal = [];
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datamaster = [];
                this.datatotal = [];
                this.tanggalsinkron = new Date();
                this.tanggaldatamonev = new Date();
                this.datakonten = [];
                this.datatahun = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>